import { render, staticRenderFns } from "./talentsTrain.vue?vue&type=template&id=b27a63da&scoped=true"
import script from "./talentsTrain.vue?vue&type=script&lang=js"
export * from "./talentsTrain.vue?vue&type=script&lang=js"
import style0 from "./talentsTrain.vue?vue&type=style&index=0&id=b27a63da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27a63da",
  null
  
)

export default component.exports